import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import reducers from './reducers';
import { HashRouter, Route, Switch } from 'react-router-dom';
import App from './App';
import Member from './Containers/Member';
import Vendor from './Containers/Vendor';
import Corporate from './Containers/Corporate';
import thunk from 'redux-thunk';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword.jsx';
import ResetPasswordScreen from './components/ResetPasswordScreen.jsx';
import ChangePassswordScreen from './components/changePassword.jsx';
import swal from 'sweetalert';


const store = createStore(
  reducers,
  applyMiddleware(thunk)
)

class ImarkPlumbingHome extends Component {
  constructor(){
  super ();
    // to transfre the storage variable added on 11th , march 2021
var sessionStorage_transfer = function(event) {
  if(!event) { event = window.event; } // ie suq
  if(!event.newValue) return;          // do nothing if no value to work with
  if (event.key == 'getSessionStorage') {
    // another tab asked for the sessionStorage -> send it
    localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
    // the other tab should now have it, so we're done with it.
    localStorage.removeItem('sessionStorage'); // <- could do short timeout as well.
  } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
    // another tab sent data <- get it
    var data = JSON.parse(event.newValue);
    for (var key in data) {
      sessionStorage.setItem(key, data[key]);
    }
  }
};

// listen for changes to localStorage
if(window.addEventListener) {
  window.addEventListener("storage", sessionStorage_transfer, false);
} else {
  
  window.attachEvent("onstorage", sessionStorage_transfer);
};


// Ask other tabs for session storage (this is ONLY to trigger event)
if (!sessionStorage.length) {
  localStorage.setItem('getSessionStorage', 'foobar');
  localStorage.removeItem('getSessionStorage', 'foobar');
  //window.location.reload();
    
}
//sessionStorage.setItem('testvalue','welcome')

  }

  componentDidMount() {
    // this.events = [
    //   "load",
    //   "mousemove",
    //   "mousedown",
    //   "click",
    //   "scroll",
    //   "keypress"
    // ];

    // this.warn = this.warn.bind(this);
    // this.logout = this.logout.bind(this);
    // this.resetTimeout = this.resetTimeout.bind(this);

    // for (var i in this.events) {
    //   window.addEventListener(this.events[i], this.resetTimeout);
    // }

    // this.setTimeout();
  
    
  }


  // clearTimeout() {
  //   if (this.warnTimeout) clearTimeout(this.warnTimeout);

  //   if (this.logoutTimeout) clearTimeout(this.logoutTimeout);
  // }

  // setTimeout() {
  //   if(window.location.hash != '#/Login' || window.location.hash != '#/logout'){
  //   this.warnTimeout = setTimeout(this.warn, 60 * 1000);

  //   this.logoutTimeout = setTimeout(this.logout, 65 * 1000);
  //   }
  // }

  // resetTimeout() {
  //   this.clearTimeout();
  //   this.setTimeout();
  // }

  // warn() {
  //   swal("You will be logged out automatically in 1 minute.");
  // }

  // logout() {
  //   // Send a logout request to the API
  //       localStorage.clear();
  //       sessionStorage.clear();
  //       swal("logged off");
  //      // window.history.replaceState({}, document.title, '/');
  //      window.location.hash = '/Login' 
  //      // this.destroy(); // Cleanup
  // }

  // destroy() {
  //   this.clearTimeout();

  //   for (var i in this.events) {
  //     window.removeEventListener(this.events[i], this.resetTimeout);
  //   }
  // }


  render() {
    return (
      <Provider store={store}>
        <HashRouter>
          <Switch>
            <Route path="/Member" render={(routeProps) => <Member role={"Member"}  {...routeProps} />} />
            <Route path="/Vendor" render={(routeProps) => <Vendor role={"Vendor"} {...routeProps} />} />
            <Route path="/Corporate" render={(routeProps) => <Corporate role={"Corporate"} {...routeProps} />} />
            <Route exact path="/Login" render={(routeProps) => <Login message={"Login to Access Dashboard"} {...routeProps} />} />
            <Route exact path="/Logout" render={(routeProps) => <Login message={"Successfully Logged Out..."}  {...routeProps} />} />
            <Route exact path="/forgot_password" render={(routeProps) => <ForgotPassword {...routeProps} />} />
            <Route exact path="/change" render={(routeProps) => <ChangePassswordScreen {...routeProps} />} />
            <Route path="/recover" render={(routeProps) => <ResetPasswordScreen {...routeProps} />} />
            <Route path="/" render={(routeProps) => <App {...routeProps} />} />
          </Switch>
        </HashRouter>
      </Provider>
    );
  }
}

export default ImarkPlumbingHome;